<template>
  
  <div id="side-nav-drawer">

    <v-list>
      <!-- Authenticated User tile -->
      <div v-if="authUser">
        <v-list-tile to="/profile" avatar>
          <v-list-tile-avatar><v-icon large>mdi mdi-account-circle</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>{{ userName }}</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </div>

      <template v-for="item in MenuItemStore.items">
        <div v-if="item.action" :key="item.action">
          <!-- Menu items -->
          <v-list-tile :to="{path: item.link}">  
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
        <!-- Dividers -->
        <div v-else-if="item.divider" :key="item.id">
          <v-divider></v-divider>
        </div>
        <!-- Subheaders -->
        <div v-else :key="item.header">
          <v-subheader v-text="item.header"></v-subheader>
        </div>
      </template>
    </v-list>

  </div>

</template>

<script>
import MenuItemStore from '../../stores/MenuItemStore.js'

export default {
  name: 'SideNavDrawer',

  props: [
    'authUser',
    'userName'
  ],

  data() {
    return {
      newMenuItem: null,
      MenuItemStore: MenuItemStore.data
    }
  },

  computed: {
    // Return true if user is not null nor undefined
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/SideNavDrawer.vue